
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/[...slug]",
      function () {
        return require("private-next-pages/lp/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/[...slug]"])
      });
    }
  